// extracted by mini-css-extract-plugin
export default {"truncatedText":"MessagesTable_truncatedText__xM8CT"};